export const getPassenger = state => state.toJS();



// WEBPACK FOOTER //
// ./src/redux/selectors/PassengerSelectors.js